import { Vue, Component } from "vue-property-decorator"
import { mapGetters } from "vuex"
import { titleCase } from "@/utils/index"

@Component({
    computed: {
        ...mapGetters(["allUser"])
    }
})
export default class CustomMixIn extends Vue {
    readonly allUser!: { [uid: string]: any }
    pagination = {
        current: 1,
        pageSize: 20,
        showQuickJumper: true,
        showSizeChanger: true,
        total: 0
    }
    sorts: any[] = []
    filters: any = []
    selectedRowKeys: number[] = []
    selectedRows: any[] = []

    // @Provide()
    // useWrapperContext = this.currentContext
    // get currentContext() {
    //     return this
    // }

    // 配置标题栏操作按钮 配置后，声明函数即可（'on' + event）。如定义的event为：add，则声明onAdd函数
    get headerActions(): { title: string; event: string }[] {
        return []
    }

    // 配置表格列
    get columns(): any[] {
        return []
    }

    // 配置表格操作栏 配置后，声明函数即可（'on' + event）。如定义的event为：add，则声明onAdd函数
    get tableActions(): (record: any) => { title: string; event: string }[] {
        return () => []
    }

    onSelectChange(selectedRowKeys: number[], selectedRows: any[]) {
        this.selectedRowKeys = selectedRowKeys
        this.selectedRows = selectedRows
    }

    created() {
        // do something
    }

    activated() {
        // do something
    }

    // 获取表格数据
    onSearch(
        keyword: string,
        pagination: any,
        sorts: any[],
        filters: any[]
    ): Promise<{ total: number; list: any[] }> {
        console.log(keyword, pagination, sorts, filters)
        return Promise.resolve({
            total: 0,
            list: []
        })
    }

    onBack() {
        this.$router.go(-1)
    }

    // 需手动设置pageHeader的action-schema为onHeaderDispatch
    onHeaderDispatch(event: string) {
        this.onDispatch({ event })
    }

    // 需手动设置advanceTable的handleSearch为onDispatch
    onDispatch(params: { event: string; payload?: any }) {
        const { event, payload } = params
        const fnName = `on${titleCase(event)}`
        const fn = (this as any)[fnName]
        if (!fn) {
            console.error(`${fnName}不存在，无法执行`)
        } else {
            fn([payload]) // 将单条记录转成数组形式，方便抽离批量操作
        }
    }

    // 需手动设置advanceTable的ref为table
    manualSearch() {
        this.pagination.current = 1
        this.selectedRowKeys = []
        this.selectedRows = []
        ;(this.$refs.table as any).onSearch()
    }
}
